module.exports = __webpack_public_path__ + "images/logo2.png?26e26e35779f04b77f30dae34889dd0c";